App.factory('reviewsService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function ReviewsService() {
        this.addReviews = function(data) {
            return baseService.post(Config.API_URL + '/remarks', data).then(function(success) {
                return success;
            }, function(error) {
                // console.log(error);
            });
        };
        
    }
    return new ReviewsService();
}]);